<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
      <div class="col-md-12">
          <div class="card mb-5">
              <div class="card-body">
                  <h4 class="mt-0 header-title" @click="backParent" style="cursor: pointer">
                      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
                      <span v-if="account.id === null"> Create Account</span>
                      <span v-else> Edit Account</span>
                  </h4>
                  <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item"><a href="#data" data-toggle="tab" aria-expanded="false" class="nav-link active">Data</a></li>
                    <li class="nav-item"><a href="#saldo" data-toggle="tab" aria-expanded="false" class="nav-link">Saldo</a></li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="data">
                      <div class="row mt-5">
                        <div class="col-md-6">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="active" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="account.active">
                              <label for="active" class="custom-control-label">Active</label>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="type_code" class="col-form-label">Account Type</label>
                            <v-select :options="typeSelect" :reduce="type => type.meta.code" label="type" v-model="account.type_code" id="type_code"/>
                            <div class="invalid-feedback">
                              Error
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="account_code" class="col-form-label">Code</label>
                            <input class="form-control" type="text" id="account_code" v-model="account.account_code" placeholder="[Auto number]">
                          </div>
                          <div class="form-group">
                            <label for="account_name" class="col-form-label">Name <span style="color:red">*</span></label>
                            <input class="form-control" type="text" id="account_name" v-model="account.account_name">
                            <div class="invalid-feedback">
                              Error
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="account_balance" class="col-form-label">Balances <span style="color:red">*</span></label>
                            <select v-model="account.account_balance" class="custom-select" id="account_balance">
                              <option value="fixasset">Fix Asset</option>
                              <option value="equity">Equity</option>
                            </select>
                            <div class="invalid-feedback">
                              Error
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="method" class="col-form-label">Method <span style="color:red">*</span></label>
                            <select v-model="account.method" class="custom-select" id="account_balance">
                              <option value="debet">Debet</option>
                              <option value="credit">Credit</option>
                            </select>
                            <div class="invalid-feedback">
                              Error
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="group_id" class="col-form-label">Group <span style="color:red">*</span></label>
                            <select v-model="account.group_id" class="custom-select" id="account_balance">
                              <option v-for="g in accountGroupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                            </select>
                            <div class="invalid-feedback">
                              Error
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="notes" class="col-form-label">Notes</label>
                            <textarea v-model="account.notes" id="notes" cols="30" rows="5" class="form-control"></textarea>
                          </div>
                          <div class="form-group">
                            <label for="company_no" class="col-form-label">Company</label>
                            <select v-model="account.company_no" class="form-control">
                              <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label for="calculate" class="col-form-label">Calculate</label>
                            <select v-model="account.calculate" class="form-control">
                              <option value="positive">Positive</option>
                              <option value="negative">Negative</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="saldo">
                      <div class="form-inline">
                        <div class="button-group">
                          <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                          <button type="button" class="btn btn-soft-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Refresh" @click="getAccountSaldo"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                        </div>
                      </div>
                      <table class="table table-item mb-0 table-sm">
                        <thead>
                          <th>Product</th>
                          <th>Method</th>
                          <th>Date</th>
                          <th class="text-right">Saldo</th>
                          <th>#</th>
                        </thead>
                        <tbody>
                          <tr v-for="s in accountSaldoList" :key="s.id">
                            <td>{{ s.product_no }}</td>
                            <td>{{ s.method }}</td>
                            <td>{{ s.saldo_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td class="text-right">{{ s.saldo }}</td>
                            <td>
                              <button type="button" class="btn btn-sm btn-soft-primary" @click="setAccountsaldoEdit(s)" data-toggle="modal" data-target="#modalAccountSaldo" data-backdrop="static" data-keyboard="false"><i class="fa fa-pencil"></i></button>
                              <button type="button" class="btn btn-sm btn-danger" @click="removeSaldo(s.id)"><i class="fa fa-trash"></i></button>
                              <!-- <button type="button" class="btn btn-sm btn-soft-primary" @click="setModal(index)">Set Modal</button> -->
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right">{{ totalAccountSaldo | currency }}</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td><span style="cursor: pointer;color: blue;" @click="setAccountsaldoAdd" data-toggle="modal" data-target="#modalAccountSaldo" data-backdrop="static" data-keyboard="false">Add Saldo</span></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
              </div>
              <div class="card-footer">
                <button type="button" @click="updateAccount" class="btn btn-primary pull-right" v-if="account.id !== null">Update</button>
                <button type="button" @click="removeAccount" class="btn btn-danger pull-right" v-if="account.id !== null">Delete</button>
                <button type="button" @click="saveAccount" class="btn btn-primary pull-right" v-else>Save</button>
              </div>
          </div>
      </div>
    </div>
    <!-- <pre>{{ accountGroupList }}</pre> -->
    <!-- <div class="row">
      <div class="col-md-4"><pre>{{ account }}</pre></div>
      <div class="col-md-4"><pre>{{ getSaldo }}</pre></div>
    </div> -->
    <ChartOfAccountModal :accountSaldo="accountSaldo" @saveAccountSaldo="saveAccountSaldo" />
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { accountUrl, getHeader } from '../../config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'
import ChartOfAccountModal from '@/components/account/ChartOfAccountModal.vue'

export default {
  name: 'ChartOfAccountForm',
  props: ['account'],
  components: {
    Loading,
    DatePicker,
    ChartOfAccountModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      accountSaldo: {
        id: null,
        account_code: null,
        saldo: null,
        saldo_date: null,
        method: 'debet',
        product_no: null
      },
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    setAccountsaldoEdit (value) {
      this.accountSaldo = value
    },
    setAccountsaldoAdd () {
      this.accountSaldo = {
        id: null,
        account_code: this.account.account_code,
        saldo: null,
        saldo_date: null,
        method: 'debet',
        product_no: null,
        term: null
      }
    },
    async saveAccountSaldo (value) {
      var saldoAmount = value.saldo.replace(/\./g, '')
      saldoAmount = saldoAmount.replace(',', '.')
      var obj = {
        id: value.id,
        account_code: this.account.account_code,
        saldo: saldoAmount,
        saldo_date: value.saldo_date,
        method: value.method,
        product_no: value.product_no,
        term: 'pass'
      }
      await axios.post(accountUrl + '/saldo', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.getAccountSaldo()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Account Saldo', error.response.data.message, 'error')
          throw error
        })
    },
    async getAccountSaldo () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var payload = {
        begin: begin,
        end: end,
        account_code: this.account.account_code
      }
      this.$store.dispatch('getAccountSaldoList', payload)
    },
    async setModal (index) {
      await this.$Progress.start()
      this.loader.isLoading = true
      const saldo = this.account.saldos[index]
      var accountCompany = saldo.account_code.substring(0, 2)
      var saldoAmount = saldo.saldo.replace(/\./g, '')
      saldoAmount = saldoAmount.replace(',', '.')
      var body = {
        account_code: accountCompany + '-310-001',
        saldo: saldoAmount,
        saldo_date: saldo.saldo_date,
        method: 'debet',
        product_no: saldo.product_no
      }
      console.log(body)
      await axios.post(accountUrl + '/saldo', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Account Saldo', response.data.message, 'success')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Account Saldo', error.response.data.message, 'error')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
    },
    async removeAccount () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.delete(accountUrl + '/' + this.account.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              this.$swal('Success', response.data.message, 'success')
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async removeSaldo (id) {
      await axios.delete(accountUrl + '/saldo/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.getAccountSaldo()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Account Saldo', error.response.data.message, 'error')
          throw error
        })
    },
    addSaldo: function () {
      const newID = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      var obj = {
        id: newID,
        saldo: 0,
        saldo_date: null,
        method: null,
        state: 'create'
      }
      this.account.saldos.push(obj)
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    saveAccount: function () {
      axios.post(accountUrl, this.account, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    updateAccount: function () {
      var obj = {
        id: this.account.id,
        type_code: this.account.type_code,
        account_code: this.account.account_code,
        account_name: this.account.account_name,
        notes: this.account.notes,
        account_balance: this.account.account_balance,
        method: this.account.method,
        group_id: this.account.group_id,
        company_no: this.account.company_no,
        calculate: this.account.calculate,
        active: this.account.active,
        saldos: this.getSaldo
      }
      axios.put(accountUrl + '/' + this.account.id, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  },
  computed: {
    ...mapState({
      chartOfAccountList: state => state.accounts.chartOfAccountList,
      accountGroupList: state => state.accounts.accountGroupList,
      companyList: state => state.companies.companyList,
      accountSaldoList: state => state.accounts.accountSaldoList
    }),
    totalAccountSaldo () {
      var array = this.accountSaldoList
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldo)
      }
      return sum
    },
    getSaldo: function () {
      var array = this.account.saldos
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var saldo = 0
        if (typeof array[i].saldo === 'string') {
          saldo = array[i].saldo.replace(/\./g, '')
          saldo = saldo.replace(',', '.')
        } else {
          saldo = array[i].saldo
        }
        var obj = {
          id: array[i].id,
          saldo: saldo,
          saldo_date: array[i].saldo_date,
          method: array[i].method,
          state: 'create',
          product_no: array[i].product_no
        }
        loop.push(obj)
      }
      return loop
    },
    typeSelect: function () {
      var loop = []
      var array = this.chartOfAccountList.filter(c => c.hierarcy === 2)
      for (let x = 0; x < array.length; x++) {
        var obj = {
          type: array[x].code + ' - ' + array[x].name,
          meta: {
            code: array[x].code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  }
}
</script>
